import { Box, Card, Checkbox, H4 } from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const HideProgram = () => {
  const { t } = useTranslation();

  const { register } = useFormContext<ProgramService.ProgramModel>();

  return (
    <Card>
      <H4>{t("programBuilder.program.checkbox.hideProgram.header")}</H4>
      <Box pY={"m"}>
        <Checkbox
          {...register("hideInProgramSelector")}
          label={t("programBuilder.program.checkbox.hideProgram.label")}
        />
      </Box>
    </Card>
  );
};
